import { LocationCategory } from '../../types';

// Границы Беларуси
export const BELARUS_BOUNDS = [
  [51.2621, 23.1783],
  [56.1726, 32.7627]
] as const;

// Маппинг категорий на кастомные SVG иконки
export const categoryIconPaths: Record<LocationCategory, string> = {
  'eco-trail': '/svg/eco-trail.svg',
  'camping': '/svg/camping.svg',
  'stargazing': '/svg/stargazing.svg',
  'picnic': '/svg/picnic.svg',
  'eco-hotel': '/svg/eco-hotel.svg',
  'estate': '/svg/estate.svg',
  'zoo': '/svg/zoo.svg',
  'Historical places': '/svg/historical-places.svg',
  'other': '/svg/other.svg'
};

export const createCustomIcon = (category: LocationCategory): string => {
  return categoryIconPaths[category] || categoryIconPaths['other'];
};